const SignIn_en = {
  ID_SIGNIN_TITLE: "Log In",
  ID_CONNECTING_WALLET_TITLE: "계정에 지갑 연결",
  ID_SIGNIN_ID_PLACEHOLDER: "Please enter your ID or email.",
  ID_SIGNIN_PWD_PLACEHOLDER: "Please enter your password.",
  ID_SIGNIN_LOGIN_BTN: "Email Log In",
  ID_SIGNIN_ERROR_EMPTY_ID: "Please enter your ID or email.",
  ID_SIGNIN_ERROR_EMPTY_PWD: "Please enter your password.",
  ID_SIGNIN_FIND_ID: "Forgot ID?",
  ID_SIGNIN_FIND_PWD: "Forgot Password?",
  ID_SIGNIN_SIGNUP_BTN: "Sign Up",
  ID_SIGNIN_LOGIN_FAIL: "Invalid ID or password.",
  ID_SIGNIN_SUBTITLE: "Connect with Redbrick",
  ID_EASY_SNS_LOGIN: "Log in easily with SNS",

  //Find ID
  ID_SIGNIN_FINDID_TITLE: "Forgot ID?",
  ID_SIGNIN_FINDID_DESC:
    "Please enter the email address registered with the account you are looking for. If you have not registered your actual email address in your account, you will not be able to receive your email.",
  ID_SIGNIN_FINDID_PLACEHOLDER: "ex)redbrick.official@redbrick.space",
  ID_SIGNIN_FINDID_SENDING: "Sending mail...",
  ID_SIGNIN_FINDID_INPUT_ERR: "This is not an email address registered with your account.",
  ID_SIGNIN_FINDID_EMPTY_ERR: "Please enter your email.",
  ID_SIGNIN_FINDID_FORMAT_ERR: "Please enter email address accordingly.",
  ID_SIGNIN_FINDID_SUBMIT_BTN: "Send Email",
  ID_SIGNIN_FINDID_SUCCESS_TITLE: "Please check your email!",
  ID_SIGNIN_FINDID_SUCCESS_SUBTITLE:
    "Please check your inbox at {email}. If you don't get an email after 3 minutes, please send the email again by pressing the [Resend] button.",
  ID_SIGNIN_FINDID_SUCCESS_BTN: "Resend",
  ID_SIGNIN_FINDID_LOST_PWD: "Did you forget your password? ",
  ID_SIGNIN_FINDID_FIND_PWD: "Find my password",

  //Find PWD
  ID_SIGNIN_FINDPWD_TITLE: "Forgot Password?",
  ID_SIGNIN_FINDPWD_DESC:
    "Please enter your ID and email to issue a temporary password. If you didn't register email address in your account, you will not be able to receive an email.",
  ID_SIGNIN_FINDPWD_ID_PLACEHOLDER: "Please enter your ID.",
  ID_SIGNIN_FINDPWD_EMAIL_PLACEHOLDER: "Please enter your authenticated email address.",
  ID_SIGNIN_FINDPWD_ID_EMPTY_ERR: "Please enter your ID.",
  ID_SIGNIN_FINDPWD_ID_INPUT_ERR: "This ID is not registered with Redbrick.",
  ID_SIGNIN_FINDPWD_INPUT_ERR: "The id or email address is not registered. Please check again.",
  ID_SIGNIN_FINDPWD_EMPTY_ERR: "Please Enter your email.",
  ID_SIGNIN_FINDPWD_FORMAT_ERR: "Please enter email address accordingly.",
  ID_SIGNIN_FINDPWD_SUBMIT_BTN: "Send Mail",
  ID_SIGNIN_FINPWD_SUCCESS_TITLE: "Temporary password has been sent.",
  ID_SIGNIN_FINDPWD_RESENT_SUCCESS: "The mail has been resent. ",

  // Guest Mode
  ID_SIGNIN_GUEST_MDOE_BTN: "GUEST MODE",

  //휴대폰 등록
  ID_SETTING_SAVE: "Save",
  ID_SETTING_SUCCESS_BTN: "Confirm",
  ID_SETTING_SENDING: "Sending...",
  ID_SETTING_PHONE_TITLE: "Register Mobile Number",
  ID_SETTING_PHONE_SUBTITLE: "Please authenticate the mobile number to be registered in your account.",
  ID_SETTING_PHONE_NUM_PLACEHOLDER: "Enter mobile number",
  ID_SETTING_PHONE_CODE_PLACEHOLDER: "Enter authentication code",
  ID_SETTING_PHONE_VERIFY_BUTTON: "Authenticate",
  ID_SETTING_PHONE_SUCCESS: "The mobile number has been authenticated.",
  ID_SETTING_PHONE_WRONG_NUM: "Enter correct mobile number",
  ID_SETTING_PHONE_DUPLICATE: "This mobile number is already registered. Please enter a different mobile number.",
  ID_SETTING_PHONE_CODE_ERR: "The authentication code is incorrect.",
  ID_SETTING_PHONE_CODE_ERR_TIMEOUT: "The authentication code has expired. Please resend code.",
  ID_SETTING_PHONE_CODE_SUCCESS: "Authentication Complete",
  ID_SETTING_VERIFY_COMPLETE: "Authentication Complete",
  ID_SETTING_VERIFY_WAIT: "Waiting for authentication...",
  ID_SETTING_PHONE_SAVE: "The mobile number has been saved.",

  // sns
  ID_KAKAO_INAPP_GOOGLE_LOGIN_ERROR: "Google login is not available with Kakao Talk policy. Please use a different web browser.",
  ID_UNLINK_SNS_GOOGLE: "Should I disconnect my Google account?",
  ID_UNLINK_SNS_NAVER: "네이버 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_KAKAO: "카카오 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_FACEBOOK: "페이스북 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_MICROSOFT: "마이크로소프트 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_UNABLE: "The SNS account selected at the time\nof initial subscription cannot be released.",
  ID_ALREADY_LINKED_SNS: "이미 다른 계정에 연동된 SNS 계정입니다.",
  ID_PWD_UNCHANGABLE: `SNS 간편 로그인으로 가입하신 경우\n비밀번호 변경을 할 수 없습니다.`,
  ID_LOGIN_EMAIL_ERROR: `SNS 회원정보의 이메일 주소가\n등록된 계정으로만 로그인 가능합니다.\n계정 정보를 확인하시고 다시 시도해 주세요.`,
};

export default SignIn_en;
